// KandySigiriyaDambullaTour.jsx
import React from "react";
import { motion } from "framer-motion";
import k1 from "../../accests/roundt/kovila (2).jpeg";
import k2 from "../../accests/roundt/kovila (1).jpeg";
import k3 from "../../accests/roundt/kovila (3).jpeg";
import k4 from "../../accests/roundt/kovila (4).jpeg";
import k5 from "../../accests/roundt/kovila (5).jpeg";
import k6 from "../../accests/kan/kan (3).jpeg";
import k7 from "../../accests/pinna/pinna (5).jpeg";
import k8 from "../../accests/sigiri/sigiri (3).jpeg";

const day1Highlights = [
    {
        title: "Pinnawala Elephant Orphanage",
        desc: "Your adventure begins with a visit to the renowned Pinnawala Elephant Orphanage, a sanctuary for orphaned and injured elephants. Watch them bathe in the river and witness baby elephants being bottle-fed.",
        img: k7,
        wiki: "https://en.wikipedia.org/wiki/Pinnawala_Elephant_Orphanage",
    },
    {
        title: "Tea Factory Tour",
        desc: "Explore a traditional tea factory and learn about Sri Lanka’s world-famous tea production process, ending with a delightful tea tasting session.",
        img: k4,
        wiki: "https://en.wikipedia.org/wiki/Tea_production_in_Sri_Lanka",
    },
    {
        title: "Royal Botanical Gardens",
        desc: "Wander through the lush Royal Botanical Gardens in Peradeniya, home to over 4,000 plant species including orchids and towering palms.",
        img: k3,
        wiki: "https://en.wikipedia.org/wiki/Royal_Botanical_Gardens,_Peradeniya",
    },
    {
        title: "Temple of the Tooth Relic",
        desc: "Visit the sacred Temple of the Tooth Relic and witness the evening ceremony followed by a traditional cultural dance performance.",
        img: k6 ,
        wiki: "https://en.wikipedia.org/wiki/Temple_of_the_Tooth",
    },


];


const day2Highlights = [
    {
        title: "Spice Garden & Hindu Temple (Matale)",
        desc: "Discover Sri Lanka’s famous spices including cinnamon, cardamom, and nutmeg, followed by a visit to a beautifully decorated Hindu temple.",
        img: k2,
        wiki: "https://en.wikipedia.org/wiki/Matale",
    },
    {
        title: "Sigiriya Rock Fortress",
        desc: "Climb the iconic Sigiriya Rock Fortress, passing ancient frescoes, landscaped gardens, and the famous Lion’s Paws.",
        img: k8,
        wiki: "https://en.wikipedia.org/wiki/Sigiriya",
    },
    {
        title: "Dambulla Cave Temple",
        desc: "Explore Sri Lanka’s largest cave temple complex featuring over 150 Buddha statues and ancient wall paintings.",
        img: k5,
        wiki: "https://en.wikipedia.org/wiki/Dambulla_cave_temple",
    },

];


const info = [
    {label: "Trip Length", value: "2 Days"},
    {label: "Language", value: "English "},
    {label: "When to Go", value: "Year-round"},
    {label: "Transfers", value: "Hotel – Tour Attractions – Hotel" },
];

const inclusions = [
    "Private luxury air-conditioned transportation throughout the tour",
    "Carefully selected accommodation with half-board meal plan",
    "Experienced and licensed English speaking chauffeur guide",
    "Entrance tickets to all listed UNESCO World Heritage Sites",
    "All sightseeing and excursion costs as per itinerary",
    "Complimentary bottled mineral water during the journey",
    "All applicable government taxes, service charges, and levies",
];


const exclusions = [
    "Additional meals & beverages beyond the meal plan",
    "Visa and flight bookings",
    "Professional English/German-speaking guides",
];

const travelTips = [
    "Temple Visits: Please wear modest clothing covering shoulders and knees when visiting religious sites.",
    "Physical Activity: This tour involves moderate walking and stair climbing, particularly at Sigiriya Rock Fortress.",
    "Accessibility Notice: The itinerary is not recommended for wheelchair users or guests with limited mobility.",
    "Recommended Essentials: Comfortable clothing, walking shoes, sun protection, swimwear, insect repellent, and a camera.",
    "Climate Advisory: Sri Lanka has a tropical climate; staying hydrated is highly recommended throughout the tour.",
];


export default function KandySigiriyaDambullaTour() {
    return (
        <div className="overflow-x-hidden">

            {/* 🔥 HERO SECTION – FULL WIDTH */}
            <section data-aos="fade-up"
                     data-aos-duration="3000" className="relative h-[70vh] w-full overflow-hidden">
                <img
                    src={k8}
                    alt="Kandy Sigiriya Dambulla Tour"
                    className="absolute inset-0 w-full h-full object-cover"
                />

                <div
                    className="absolute inset-0 bg-gradient-to-b from-black/60 to-black/30 flex flex-col items-center justify-center text-center px-4">
                    <h1 className="text-4xl md:text-6xl text-white font-bold mb-4">
                        Kandy, Sigiriya & Dambulla
                    </h1>
                    <p className="text-lg md:text-2xl text-white/90 max-w-3xl">
                        Maximizing cultural heritage: A 48-hour guide to three UNESCO landmarks!
                    </p>
                </div>
            </section>

            <div className="max-w-7xl mx-auto px-4 py-16 space-y-16">

            {/* Day 1 Highlights */}
            <section data-aos="fade-up"
                     data-aos-duration="3000" className="space-y-12">
                <h2 className="text-3xl font-bold text-center mb-8">Day 1 - Kandy Highlights</h2>
                {day1Highlights.map((item, idx) => (
                    <motion.div
                        key={idx}
                        initial={{opacity: 0, x: idx % 2 === 0 ? -50 : 50}}
                        whileInView={{opacity: 1, x: 0}}
                        viewport={{once: true}}
                        className={`md:flex md:items-center md:space-x-8 bg-white shadow-lg rounded-xl overflow-hidden ${
                            idx % 2 === 1 ? "md:flex-row-reverse" : ""
                        }`}
                    >
                        <img
                            src={item.img}
                            alt={item.title}
                            className="md:w-1/2 h-64 object-cover"
                        />

                        <div className="p-6 md:w-1/2">
                            <h3 className="text-2xl font-bold mb-4">{item.title}</h3>
                            <p className="text-gray-700">{item.desc}</p>
                            <a
                                href={item.wiki}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="inline-flex items-center mt-4 text-blue-600 font-semibold hover:text-blue-800 transition"
                            >
                                Read More →
                            </a>

                        </div>
                    </motion.div>

                ))}
            </section>

            {/* Day 2 Highlights */}
            <section data-aos="fade-up"
                     data-aos-duration="3000" className="space-y-12">
                <h2 className="text-3xl font-bold text-center mb-8">Day 2 - Sigiriya & Dambulla</h2>
                {day2Highlights.map((item, idx) => (
                    <motion.div
                        key={idx}
                        initial={{opacity: 0, x: idx % 2 === 0 ? -50 : 50}}
                        whileInView={{opacity: 1, x: 0}}
                        viewport={{once: true}}
                        className={`md:flex md:items-center md:space-x-8 bg-white shadow-lg rounded-xl overflow-hidden ${
                            idx % 2 === 1 ? "md:flex-row-reverse" : ""
                        }`}
                    >
                        <img
                            src={item.img}
                            alt={item.title}
                            className="md:w-1/2 h-64 object-cover"
                        />
                        <div className="p-6 md:w-1/2">
                            <h3 className="text-2xl font-bold mb-4">{item.title}</h3>
                            <p className="text-gray-700">{item.desc}</p>
                            <a
                                href={item.wiki}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="inline-flex items-center mt-4 text-blue-600 font-semibold hover:text-blue-800 transition"
                            >
                                Read More →
                            </a>

                        </div>
                    </motion.div>
                ))}
            </section>

            {/* Tour Info */}
            <section data-aos="fade-up"
                     data-aos-duration="3000"
                className="bg-blue-50 p-8 rounded-xl shadow-lg grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                {info.map((item, idx) => (
                    <div key={idx} className="text-center">
                        <h4 className="text-lg font-semibold mb-2">{item.label}</h4>
                        <p className="text-gray-700">{item.value}</p>
                    </div>
                ))}
            </section>

            {/* Inclusions & Exclusions */}
            <section data-aos="fade-up"
                     data-aos-duration="3000" className="grid md:grid-cols-2 gap-8">
                <div className="bg-white p-6 rounded-xl shadow-lg">
                    <h3 className="text-2xl font-bold mb-4">Tour Inclusions</h3>
                    <ul className="list-disc list-inside space-y-2 text-gray-700">
                        {inclusions.map((inc, idx) => (
                            <li key={idx}>{inc}</li>
                        ))}
                    </ul>
                </div>
                <div className="bg-white p-6 rounded-xl shadow-lg">
                    <h3 className="text-2xl font-bold mb-4">Tour Exclusions</h3>
                    <ul className="list-disc list-inside space-y-2 text-gray-700">
                        {exclusions.map((exc, idx) => (
                            <li key={idx}>{exc}</li>
                        ))}
                    </ul>
                </div>
            </section>

            {/* Travel Tips */}
            <section data-aos="fade-up"
                     data-aos-duration="3000" className="bg-gray-50 p-6 rounded-xl shadow-lg space-y-4">
                <h3 className="text-2xl font-bold mb-4">Travel Tips</h3>
                <ul className="list-disc list-inside text-gray-700 space-y-2">
                    {travelTips.map((tip, idx) => (
                        <li key={idx}>{tip}</li>
                    ))}
                </ul>
            </section>

            {/* CTA */}
            <section className="text-center">
                <motion.a
                    whileHover={{scale: 1.05}}
                    whileTap={{scale: 0.95}}
                    href="https://wa.me/94770163670?text=Hello%20Ranmali%20Tours%2C%20I%20would%20like%20to%20book%20a%20tour."
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block bg-green-600 text-white px-8 py-4 rounded-xl font-semibold shadow-lg hover:bg-green-700 transition"
                >
                    Book Your Adventure Today
                </motion.a>
            </section>
            </div>

        </div>
    );
}
